// @flow
import * as React from 'react';
import debounce from 'lodash.debounce';
import { isEmpty } from 'utils/functional';
import DateTimeLoadable from './DateTimeLoadable';
import 'moment/locale/pt';

const disablePastDatesValidator = currentDate => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return currentDate.isAfter(yesterday.toDateString());
};

const DatePicker = ({
  value,
  onChange,
  hasError,
  disablePastDates,
  preParse = true,
  strictParsing = true,
  dateFormat,
  ...rest
}: {
  value: ?string,
  onChange: (?string) => void,
  hasError?: boolean,
  disablePastDates?: boolean,
  preParse?: boolean,
  strictParsing?: boolean,
  dateFormat?: string | boolean
}) => {
  const datetimeProps = {
    ...rest,
    autoComplete: 'off'
  };
  const onChangeDebounced = debounce(onChange, 200);
  return (
    <DateTimeLoadable
      timeFormat={false}
      locale={USER_LOCALE}
      utc
      inputProps={datetimeProps}
      closeOnSelect
      hasError={hasError}
      dateFormat={dateFormat || 'MM/DD/YYYY'}
      isValidDate={disablePastDates ? disablePastDatesValidator : null}
      strictParsing={strictParsing}
      value={value ? (preParse ? new Date(value) : value) : null}
      onChange={selectedDate => {
        if (typeof selectedDate === 'string') {
          if (isEmpty(selectedDate)) {
            onChangeDebounced(null);
          }
        } else if (selectedDate.isValid()) {
          onChangeDebounced(selectedDate.format('YYYY-MM-DD'));
        } else {
          onChangeDebounced(null);
        }
      }}
    />
  );
};

export default DatePicker;
